import { render, staticRenderFns } from "./choice_auth.vue?vue&type=template&id=656850bb&scoped=true&"
import script from "./choice_auth.vue?vue&type=script&lang=js&"
export * from "./choice_auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656850bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656850bb')) {
      api.createRecord('656850bb', component.options)
    } else {
      api.reload('656850bb', component.options)
    }
    module.hot.accept("./choice_auth.vue?vue&type=template&id=656850bb&scoped=true&", function () {
      api.rerender('656850bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/choice/auth/choice_auth.vue"
export default component.exports